<template>
  <div class="ingredients__container container-fluid">
    <div class="add-ingredients__header row align-middle">
            <div class="col-1"></div>
            <div class="col-1 text-center"><h3>Amount</h3></div>
            <div class="col-2 text-center"><h3>Units</h3></div>
            <div class="col-1 text-center"><h3>Grams</h3></div>
            <div class="col-2 text-center"><h3>Item Code</h3></div>
            <div class="col-2 text-center"><h3>Specifications</h3></div>
            <div class="col-2 text-center"><h3>Preparation</h3></div>
            <div class="col-1 text-center"><h3>Remove</h3></div>
    </div>
    <div class="add-ingredients__body">
      <draggable v-model="savedIngredients">
        <div 
        v-for='(item, index) in savedIngredients'
       :key='item.id'
        :data-id="index"
        draggable
        @start="startDrag(evt)" 
        @end="onDrop(evt)">
          <div class="drag-el">
            <div class="ingredient-item">
              <div class='col-1' style="height:105px;">
                <p>
                  <i class="fas fa-arrows-alt"></i>
                </p>
              </div>
              <div class='col-1 text-center' style="float:right;height:105px;margin-top:10px;">
                <span
                  v-on:click="removeRow(item)"
                  class="shortcut-media avatar rounded-circle bg-gradient-red">
                  <i class="fas fa-minus"></i>
                </span>
              </div>
              <div class='col-10'>
                <p>
                  <base-input
                    ref="specbox"
                    name="ingredientName"
                    type="text"
                    placeholder="Name"
                    v-if="item.subRecipeId == undefined || item.subRecipeId == '00000000-0000-0000-0000-000000000000'"
                    v-on:input="updateIngredientAmount(item)"
                    v-model="item.ingredientName">
                  </base-input>
                  <span v-if="item.subRecipeId != undefined && item.subRecipeId != '00000000-0000-0000-0000-000000000000'" v-html="item.ingredientName"></span>
                </p>
              </div>
              <div class='col-10' style="margin-top: 10px;">
                <div class='col-2'>
                  <base-input
                    name="amount"
                    type="text"
                    placeholder="Amount"
                    v-on:input="updateIngredientAmount(item)"
                    v-model="item.volume">
                  </base-input>
                </div>
                <div class='col-2'>
                  <base-input
                    name="amount"
                    type="text"
                    placeholder="Amount"
                    v-on:input="updateIngredientAmount(item)"
                    v-model="item.unitName">
                  </base-input>
                </div>
                <!--
                <div class='col-2'>
                  <div v-show="unitsLoading" class="loading">
                    <loading-panel></loading-panel>
                  </div>
                  <base-input>
                  <el-select
                    v-model="item.unitId"
                    filterable
                    v-on:input="updateIngredientAmount(item)"
                    placeholder="Select Unit"
                    v-show="!unitsLoading"
                  >
                    <el-option v-for="(option, index) in possibleUnits"
                      :key="index"
                      :label="option.name"
                      :value="option.id">
                    </el-option>
                  </el-select>
                </base-input>
                </div>
              -->
                <div class='col-2'>
                  <base-input
                    name="grams"
                    type="text"
                    placeholder="Grams"
                    v-on:input="updateIngredientAmount(item)"
                    v-model="item.grams">
                  </base-input>
                </div>
                <div class='col-2'>
                  <base-input
                    name="itemCode"
                    type="text"
                    placeholder="Item Code"
                    v-on:input="updateIngredientAmount(item)"
                    v-model="item.itemCode">
                  </base-input>
                </div>
                <div class='col-2'>
                  <base-input
                    name="spec"
                    type="text"
                    placeholder="Specifications"
                    v-on:input="updateIngredientAmount(item)"
                    v-model="item.spec">
                  </base-input>
                </div>
                <div class='col-2' style="padding-right:0px;">
                  <base-input
                    name="prep"
                    type="text"
                    placeholder="Preparation"
                    v-on:input="updateIngredientAmount(item)"
                    v-model="item.prep">
                  </base-input>
                </div>
              </div>
              <div class='col-10' style="margin-top: 10px;">
                <base-input
                  name="uri"
                  type="text"
                  placeholder="Uri"
                  v-on:input="updateIngredientAmount(item)"
                  v-model="item.uri">
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </draggable>
    </div>
    <div class="form-row">
      <b-col sm="12" md="6">
        <label class="form-control-label mt-5">Add New Ingredient</label>
        <SearchIngredients
          @newIngredient="addNewIngredient"
        />
      </b-col>
      <b-col sm="12" md="6">
        <label class="form-control-label mt-5">Add New SubRecipe</label>
        <SearchRecipes
          @newSubRecipe="addNewSubRecipe"
        />
      </b-col>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import SearchIngredients from './SearchIngredients.vue';
import SearchRecipes from './SearchRecipes.vue';
import BaseInput from '../../components/Inputs/BaseInput.vue';
import draggable from 'vuedraggable';
import LoadingPanel from '@/components/LoadingPanel.vue';

export default {
  name: "RecipeEditIngredients",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    SearchIngredients,
    SearchRecipes,
    BaseInput,
    LoadingPanel,
    draggable
  },
  props: {
    ingredients: Array
  },
  data () {
    return {
    }
  },
  computed: {
    savedIngredients: {
      get: function() {
        return (this.$store.state.ingredients.saved == '') ? [] : this.$store.state.ingredients.saved;
      },
      set: function(value) {
        this.$store.dispatch('ingredients/setSavedIngredients', value)
      },
    },
    possibleUnits() {
      return Object.values(this.$store.state.units.selectList)
    },
    unitsLoading() {
      return this.$store.state.units.loading
    }
  },
  beforeDestroy() {
  },
  methods: {
    setIngredients() {
      const { dispatch } = this.$store;
      dispatch("ingredients/setSavedIngredients", this.savedIngredients);
    },
    updateIngredientAmount(row) {
      const item = this.savedIngredients.find(item => item.rid == row.rid )
      item.itemCode = row.itemCode
      item.spec = row.spec
      item.prep = row.prep
      item.volume = row.volume
      item.unitName = row.unitName
      item.unit = row.unit
      item.grams = row.grams
      this.setIngredients()
    },
    removeRow(item){
      this.savedIngredients.splice(this.savedIngredients.findIndex(function(i){
          return i.id === item.id;
      }), 1);
      this.setIngredients()
    },
    startDrag: (evt) => {
    },
    onDrop (evt) {
    },
    addNewIngredient(ingredient) {
      var ri = { "ingredientId": ingredient.Id, "ingredient": ingredient, "ingredientName": ingredient.description, "position": this.savedIngredients.length + 1, "sortOrder": ingredient.position };
      ri.rid = Date.now().toString(36) + Math.random().toString(36).substring(2);

      this.savedIngredients.push(ri)
      this.setIngredients()
    },
    addNewSubRecipe(recipe) {
      var ri = { "subRecipeId": recipe.id, "ingredientName": recipe.name, "subRecipe": recipe, "position": this.savedIngredients.length + 1, "sortOrder": recipe.position };
      ri.rid = Date.now().toString(36) + Math.random().toString(36).substring(2);
      this.savedIngredients.push(ri)
      this.setIngredients()
    },
    setOtherPosition(start, end){
      const item = this.savedIngredients.splice(this.savedIngredients.findIndex(function(i){
          return i.position === end;
      }), 1);
      item.position = start
      item.sortOrder = start
      this.savedIngredients.push(item[0])
      this.setIngredients()
    }
  },
  watch: {
     unitsLoading (newLoad, oldLoad) {
         this.unitsLoading = newLoad
     }
  }
}
</script>

<style scoped>
  .ingredient-item div { float: left; }

  .add-ingredients__body .col-2 { padding-left: 0px; }
</style>